import React from 'react'
import EditSelectionContainer from '../../../containers/PageEditSelection/EditSelectionContainer'
import OverlayWrapper from './OverlayWrapper'

const OverlayEditSelection = ({isEditingSelection}) => (
    isEditingSelection ? (
        <OverlayWrapper className=' is-scrollable'>
            <EditSelectionContainer
                selectionId={isEditingSelection}
            />
        </OverlayWrapper>
    ) : ('')
)

export default OverlayEditSelection